import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { BASE_URL } from "../../../utils/constant";

export default function AddProjectform({ onClose, userId, selectedMember }) {
  const [suggestedProjects, setSuggestedProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [addingId, setAddingId] = useState(null);
  const [addError, setAddError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    async function fetchSuggestions() {
      setLoading(true);
      setError("");
      try {
        const accessToken = localStorage.getItem("access");
        const organization_id = JSON.parse(localStorage.getItem("organization"))?.id;
        if (!accessToken || !organization_id) throw new Error("Missing credentials");
        // Get all sites
        const res = await fetch(`${BASE_URL}/sites/organizations/${organization_id}/sites/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const sites = await res.json();
        // For each site, check if user is a member
        const suggestions = [];
        for (const site of sites) {
          const membersRes = await fetch(`${BASE_URL}/team/list-site-members/${site.id}/`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          });
          const membersData = await membersRes.json();
          const members = membersData.status ? membersData.data : [];
          const isUserMember = members.some((m) => String(m.user_id) === String(userId));
          if (!isUserMember) {
            suggestions.push(site);
          }
        }
        setSuggestedProjects(suggestions);
      } catch (e) {
        setError("Failed to load suggestions");
      }
      setLoading(false);
    }
    if (userId) fetchSuggestions();
  }, [userId]);

  async function handleAdd(siteId) {
    setAddingId(siteId);
    setAddError("");
    setSuccess("");
    try {
      const accessToken = localStorage.getItem("access");
      const organization_id = JSON.parse(localStorage.getItem("organization"))?.id;
      if (!accessToken || !organization_id) throw new Error("Missing credentials");
      // Prepare request body
      const requestBody = {
        is_admin: false,
        view_material_management: false,
        view_worker_management: false,
        view_finance: false,
        view_all: false,
        edit_material_management: false,
        edit_worker_management: false,
        edit_finance: false,
        edit_all: false,
        member_control: false,
        joined_as: "member",
        organization_member: selectedMember?.id,
        sites: siteId,
      };
      console.log("Adding member with request body:", requestBody);
      const response = await fetch(`${BASE_URL}/team/add-member/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(requestBody),
      });
      if (!response.ok) throw new Error("Failed to add member to project");
      setSuccess("Added to project!");
      // Remove the added project from suggestions
      setSuggestedProjects(prev => prev.filter(p => p.id !== siteId));
    } catch (e) {
      setAddError("Failed to add member");
    }
    setAddingId(null);
  }

  const filteredSuggestions = suggestedProjects
    .filter(p => p.site_name.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => {
      const aIndex = a.site_name.toLowerCase().indexOf(search.toLowerCase());
      const bIndex = b.site_name.toLowerCase().indexOf(search.toLowerCase());
      return (aIndex === -1 ? 9999 : aIndex) - (bIndex === -1 ? 9999 : bIndex);
    })
    .slice(0, 5);

  return (
    <div className="w-[380px] max-w-full relative">
      {/* Modal Header */}
      <div className="flex items-center justify-center mb-4 relative">
        <h2 className="text-lg font-semibold text-center w-full">Add More Projects</h2>
        {/* Only one close button is rendered here */}
        <button
          className="absolute right-0 top-0 text-gray-500 hover:text-gray-700 text-2xl font-bold focus:outline-none"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
      </div>
      {/* Search Bar */}
      <div className="relative mb-6">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
          <FiSearch size={18} />
        </span>
        <input
          type="text"
          placeholder="Site name"
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-400 bg-gray-50"
        />
      </div>
      {/* Suggested Projects */}
      <div>
        <div className="text-xs text-gray-400 mb-2">Suggested projects:</div>
        {loading ? (
          <div className="text-sm text-gray-400">Loading...</div>
        ) : error ? (
          <div className="text-sm text-red-500">{error}</div>
        ) : filteredSuggestions.length === 0 ? (
          <div className="text-sm text-gray-400">No suggestions available</div>
        ) : (
          <ul className="space-y-2">
            {filteredSuggestions.map((project) => (
              <li
                key={project.id}
                className={`px-4 py-2 rounded-lg cursor-pointer hover:bg-purple-50 transition border border-transparent hover:border-purple-200 text-gray-700 flex justify-between items-center ${addingId === project.id ? 'opacity-60 pointer-events-none' : ''}`}
                onClick={() => handleAdd(project.id)}
              >
                <span>{project.site_name}</span>
                {addingId === project.id && <span className="text-xs text-purple-400 ml-2">Adding...</span>}
              </li>
            ))}
          </ul>
        )}
        {addError && <div className="text-sm text-red-500 mt-2">{addError}</div>}
        {success && <div className="text-sm text-green-600 mt-2">{success}</div>}
      </div>
    </div>
  );
}
